// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-icon {
  font-size: 54px;
}

.info-row {
  display: flex;
  font-size: 21px;
  font-weight: 600;
}

.margin-right {
  margin-right: 16px;
}

ion-text.padding-left {
  padding-left: 5px;
}

ion-label {
  margin-right: 0;
}
ion-label .display-name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-label .address {
  font-size: 14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-label ion-icon {
  width: 11px;
  flex-shrink: 0;
  flex-grow: 0;
}

ion-popover.display-name {
  --width: 275px;
}
ion-popover.display-name ion-icon {
  font-size: 16px;
}
ion-popover.display-name ion-label {
  margin: 5px 10px;
}
ion-popover.display-name ion-label .displayName,
ion-popover.display-name ion-label .address,
ion-popover.display-name ion-label .emailAddress {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 7px 0;
}
ion-popover.display-name ion-label .displayName div,
ion-popover.display-name ion-label .address div,
ion-popover.display-name ion-label .emailAddress div {
  display: flex;
}
ion-popover.display-name ion-label .address {
  font-size: 12px !important;
}
ion-popover.display-name ion-label .address ion-icon {
  font-size: 16px;
}
ion-popover.display-name ion-label .displayName {
  font-size: 15px;
}
ion-popover.display-name ion-label .emailAddress ion-icon {
  color: #6e6e6e;
}
ion-popover.display-name ion-label .emailAddress small {
  color: #6e6e6e;
  font-size: 12px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/place-location-info/place-location-info.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AACA;EACE,eAAA;AAEF;AADE;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AAGJ;AADE;EACE,eAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AAGJ;AADE;EACE,WAAA;EACA,cAAA;EACA,YAAA;AAGJ;;AACA;EACE,cAAA;AAEF;AADE;EACE,eAAA;AAGJ;AADE;EACE,gBAAA;AAGJ;AAFI;;;EAGE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;AAIN;AAHM;;;EACE,aAAA;AAOR;AAJI;EACE,0BAAA;AAMN;AAJM;EACE,eAAA;AAMR;AAHI;EACE,eAAA;AAKN;AAFM;EACE,cAAA;AAIR;AAFM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAIR","sourcesContent":["ion-icon {\n  font-size: 54px;\n}\n\n.info-row {\n  display: flex;\n  font-size: 21px;\n  font-weight: 600;\n}\n\n.margin-right {\n  margin-right: 16px;\n}\n\nion-text.padding-left {\n  padding-left: 5px;\n}\nion-label {\n  margin-right: 0;\n  .display-name {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  .address {\n    font-size: 14px;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  ion-icon {\n    width: 11px;\n    flex-shrink: 0;\n    flex-grow: 0;\n  }\n}\n\nion-popover.display-name {\n  --width: 275px;\n  ion-icon {\n    font-size: 16px;\n  }\n  ion-label {\n    margin: 5px 10px;\n    .displayName,\n    .address,\n    .emailAddress {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      margin: 7px 0;\n      div {\n        display: flex;\n      }\n    }\n    .address {\n      font-size: 12px !important;\n      // margin-left: -2px;\n      ion-icon {\n        font-size: 16px;\n      }\n    }\n    .displayName {\n      font-size: 15px;\n    }\n    .emailAddress {\n      ion-icon {\n        color: #6e6e6e;\n      }\n      small {\n        color: #6e6e6e;\n        font-size: 12px;\n        font-weight: 500;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
